import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconAlarmOn = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11 2.85969L8.7 0.929688L8.055 1.69469L10.355 3.62469L11 2.85969ZM3.94 1.69469L3.3 0.929688L1 2.85469L1.645 3.61969L3.94 1.69469ZM6.25 3.99969H5.5V6.99969L7.875 8.42469L8.25 7.80969L6.25 6.62469V3.99969ZM6 1.99969C3.515 1.99969 1.5 4.01469 1.5 6.49969C1.5 8.98469 3.51 10.9997 6 10.9997C8.485 10.9997 10.5 8.98469 10.5 6.49969C10.5 4.01469 8.485 1.99969 6 1.99969ZM6 9.99969C4.065 9.99969 2.5 8.43469 2.5 6.49969C2.5 4.56469 4.065 2.99969 6 2.99969C7.935 2.99969 9.5 4.56469 9.5 6.49969C9.5 8.43469 7.935 9.99969 6 9.99969Z",
		fill: "#60A5FA"
	})
});
export default SvgIconAlarmOn;
